import React from "react";

/**
 * UniVicoustic logo component.
 * - `variant="full"` (default) renders the wordmark as native HTML text so the
 *   surrounding background shows through cleanly — no PNG/JPG dependency, no
 *   blend-mode trickery, works on any backdrop including the 3D login stage.
 * - `variant="mark"` renders just the compact mark for tight spaces (admin chrome).
 * - `variant="image"` renders the original JPG (kept for places we want the
 *   detailed lockup, e.g., the PDF certificate).
 */
export default function Logo({ className = "h-8", variant = "full" }) {
  if (variant === "mark") {
    return (
      <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
        <svg viewBox="0 0 40 40" className="h-full w-auto" aria-label="UniVicoustic">
          <rect x="0" y="0" width="40" height="40" rx="8" fill="#222222"/>
          <text x="20" y="27" textAnchor="middle" fontFamily="Manrope, sans-serif" fontWeight="900" fontSize="20" fill="#fff">U</text>
          <path d="M12 30 L20 38 L28 30" stroke="#E53935" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
        </svg>
      </div>
    );
  }
  if (variant === "image") {
    return (
      <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
        <img src="/univicoustic-logo.jpg" alt="UniVicoustic" className="h-full w-auto object-contain" draggable="false" />
      </div>
    );
  }
  return (
    <div
      className={`inline-flex flex-col items-center justify-center select-none ${className}`}
      data-testid="brand-logo"
      aria-label="UniVicoustic — Makes Sound Sense"
    >
      <div
        className="font-display font-extrabold tracking-tight leading-none"
        style={{ fontSize: "calc(0.7em + 0.5rem)" }}
      >
        <span className="text-[#222222]">UNI</span>
        <span className="text-[#E53935]">V</span>
        <span className="text-[#E53935]">/</span>
        <span className="text-[#222222]">COUSTIC</span>
      </div>
      <div
        className="text-[#E53935] font-bold tracking-[0.3em] mt-1"
        style={{ fontSize: "calc(0.18em + 0.32rem)" }}
      >
        MAKES SOUND SENSE
      </div>
    </div>
  );
}
